import { Pipe, PipeTransform } from '@angular/core';
import { UpperCasePipe } from '@angular/common';

@Pipe({
	standalone: true,
	name: 'toutesLettresMajusculePipe'
})
export class ToutesLettresMajusculePipe implements PipeTransform {

	constructor(private upperCasePipe: UpperCasePipe) {
	}

	transform(value: string | unknown): string {
		if (!value || typeof value !== 'string') {
			return '';
		}
		return this.upperCasePipe.transform(value);
	}

}
